import React, { Fragment, useState, useEffect } from 'react'
import { Link } from 'gatsby'

import LogoNovafarmaDesktop from '../../assets/images/desktop/logo-nova-farma.svg'
import LogoNovafarmaMobile from '../../assets/images/mobile/logo-nova-farma.png'
import './header.css'

const Sidebar = () => {
  const [openSideBar, setOpenSidebar] = useState(false)
  const [displayDropDown, setDisplayDropDown] = useState(false)
  const [displayNavMobile, setDisplayNavMobile] = useState(false)

  const [currentStore, setCurrentStore] = useState(null)

  useEffect(() => {
    const current = JSON.parse(window.localStorage.getItem('currentStore'))
    setCurrentStore(current)
  }, [])

  return (
    <Fragment>
      <nav>
        {/* Desktop */}
        <div id="navbar-desktop" className="navbar-expand-sm header-display">
          <div className="d-flex flex-column">
            <div className="theme--primary d-flex flex-column justify-content-center">
              <div className="container">
                <div className="row">
                  <div className="col-2 p-0">
                    <div className="sidebar-header">
                      <Link to="/"><img className="sidebar-logo" src={LogoNovafarmaDesktop} title="Logotipo da NovaFarma" alt="Logotipo da Novafarma"/></Link>
                    </div>
                  </div>
                  <div className="col-4 item-store d-flex flex-column justify-content-center align-items-center">
                    <Link to="/lojas/" className="btn theme-secundary"><span className="ml-3">NOSSAS LOJAS</span></Link>
                  </div>
                  <div className="col-3 item-offers-week d-flex flex-column justify-content-center align-items-center">
                    <Link to="/ofertas/" className="btn theme--secundary text-white"><span className="ml-3">OFERTAS</span></Link>
                  </div>
                  <div className="store-name-desktop col-3 d-flex flex-column align-items-end">
                    {currentStore !== null ? (
                      <p className="my-auto text-white">
                        <span className="d-none d-xl-inline">Olá! Você está na </span>
                        <Link to={`/lojas/${currentStore.slug}/contato/`} className="text-white store-name mr-3">LOJA {currentStore.storeNumber}</Link>
                      </p>
                    ) : (
                      <p className="my-auto text-white"><Link to="/lojas/" title="Escolha uma loja" className="text-white store-name mr-3">Escolha uma loja</Link></p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="theme--quinary d-flex flex-column justify-content-center">
              <div className="container">
                <div className="row">
                  <ul className="navbar-nav justify-content-between w-100">
                    <li>
                      <Link to="/" className="nav-link">HOME</Link>
                    </li>
                    <li>
                      <Link to="/quem-somos/" className="nav-link">QUEM SOMOS</Link>
                    </li>
                    <li>
                      <Link to="/lojas/" className="nav-link">ENCONTRE UMA LOJA</Link>
                    </li>
                    <li>
                      <Link to="/ofertas/" className="nav-link">OFERTAS</Link>
                    </li>
                    <li className="dropdown btn-group">
                      <a href="#" id="dropdownConvenio" className="dropdown-toggle nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"
                        onClick={() => setDisplayDropDown(!displayDropDown)}>CONVÊNIOS</a>
                      <div className={displayDropDown === true ? 'dropdown-menu show' : 'dropdown-menu'} aria-labelledby="dropdownConvenio">
                        <Link to="/convenio-empresarial/" className="dropdown-item">CONVÊNIO EMPRESARIAL</Link>
                        <Link to="/convenios-parcerias/" className="dropdown-item">DESCONTOS E PARCERIAS</Link>
                      </div>
                    </li>
                    <li>
                      <Link to="/trabalhe-conosco/" className="nav-link">TRABALHE CONOSCO</Link>
                    </li>
                    <li>
                      <Link to="/contato/" className="nav-link">CONTATO</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Mobile Sidebar */}
        <div id="fixed-mobile" className="wrapper theme--primary d-none">
          <div id="sidebar" className={openSideBar ? 'active' : ''}>
            <div id="dismiss" className="position-absolute" onClick={() => setOpenSidebar(false)}><span className="sr-only">Fechar menu</span></div>
            <div className="sidebar-header d-flex flex-column justify-content-center align-items-center theme--primary">
              <Link to="/"><img src={LogoNovafarmaMobile} title="Logotipo da Novafarma" alt="Logotipo da Novafarma"/></Link>
            </div>
            <ul className="list-unstyled CTAs pt-4 pb-2 px-auto">
              <li>
                <Link to="/lojas/" className="d-block text-center m-auto theme-border-2 theme--secundary btn-store-us text-decoration-none">NOSSAS LOJAS</Link>
              </li>
              <li className="mt-3">
                <Link to="/ofertas/" className="d-block text-center m-auto theme-border-2 theme--primary btn-offers-week">OFERTAS RELÂMPAGO</Link>
              </li>
            </ul>
            <hr className="theme-border-2" />
            <ul className="position-relative mobile-links my-0 list-unstyled components text-center">
              <li>
                <Link to="/">HOME</Link>
              </li>
              <li>
                <Link to="/quem-somos/">QUEM SOMOS</Link>
              </li>
              <li className="mobile-dropdown">
                <a href="#" id="agreement-dropdown-button" onClick={() => setDisplayNavMobile(!displayNavMobile)}>CONVÊNIOS<span className="dropdown-arrow"></span></a>
                <ul id="agreement-dropdown" className={displayNavMobile === true ? 'active' : ''}>
                  <li><Link to="/convenio-empresarial/">CONVÊNIO EMPRESARIAL</Link></li>
                  <li><Link to="/convenios-parcerias/">DESCONTOS <br/>E PARCERIAS</Link></li>
                </ul>
              </li>
              <li>
                <Link to="/trabalhe-conosco/">TRABALHE CONOSCO</Link>
              </li>
              <li>
                <Link to="/contato/">CONTATO</Link>
              </li>
            </ul>
            <ul id="social-media" className="list-inline text-center">
              <li className="list-inline-item">
                <a href="https://www.instagram.com/novafarma/" title="Instagram NovaFarma"><span className="sr-only">Instagram</span></a>
              </li>
              <li className="list-inline-item">
                <a href="https://www.facebook.com/droganovafarma/" title="Facebook NovaFarma"><span className="sr-only">Facebook</span></a>
              </li>
            </ul>
          </div>
          <div id="mobile-menu" className="container d-flex flex-column justify-content-center">
            <div className="row">
              <div className="col-2 p-md-0 d-flex flex-column justify-content-center">
                <button type="button" className="hamburguer position-relative d-flex flex-column justify-content-center" onClick={() => setOpenSidebar(true)}>
                  <div className="position-relative line theme-border-2"></div>
                  <div className="position-relative line theme-border-2"></div>
                  <div className="position-relative line theme-border-2"></div>
                  <span className="sr-only">Abrir menu</span>
                </button>
              </div>
              <div className="col-5 col-md-8 p-md-0 d-flex flex-column  align-items-md-center">
                <Link to="/" className="d-flex flex-column justify-content-center"><img src={LogoNovafarmaDesktop} title="Logotipo da Novafarma" alt="Logotipo da Novafarma"/></Link>
              </div>
              <div className="col-5 col-md-2 p-md-0 d-flex flex-column align-items-end">
              </div>
            </div>
          </div>
          <div onClick={() => setOpenSidebar(false)} className={openSideBar ? 'overlay active' : ''}></div>
        </div>
      </nav>
    </Fragment>
  )
}

export default Sidebar
